const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  // DOMAIN SERVER MỚI
  development: {
    api: " https://hueplan-api.cgis.asia/",
    media_url: " https://hueplan-api.cgis.asia/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
    workSpace: "hueplan",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
    datastore: 'hueplan',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
    // wmsBaseLink: "https://geoserver.phutho.gov.vn/geoserver/gwc/service/wms/",
  },
    production: {
      api: " https://hueplan-api.cgis.asia/",
      media_url: " https://hueplan-api.cgis.asia/",
      domainAdminSide: "https://admin.hueplan.cgis.asia",
      domainUserSide: "https://hueplan.cgis.asia",
      domainName: "hueplan.cgis.asia",
      workSpace: "hueplan",
      wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
      datastore: 'hueplan',
      gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
      // wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
  }
};

module.exports = apiEnvironment[env];